"use strict";

let TrackingEvent = require('../models/TrackingEvent');

const TRACKING_DATA_CLICK_ATTRIBUTE = '[data-track-click]';
const TRACKING_DATA_ENTER_ATTRIBUTE = '[data-track-enter]';
const TRACKING_DATA_SUBMIT = '[data-track-submit]';
const TRACKING_CLICK_PROP = 'trackClick';
const TRACKING_ENTER_PROP = 'trackEnter';
const TRACKING_SUBMIT_PROP = 'trackSubmit';
const ENTER_KEY_CODE = 13;
const EVENT_TRACKING_ENDPOINT = '/event-tracking-registration';

const location = () => window.location.href.split("?")[0];
const eventUrl = () => window.location.href;

class PageEventTracker {
    constructor(client) {
        this.client = client;
    }

    log(payload) {
        this.client.post(payload, EVENT_TRACKING_ENDPOINT);
    }

    logCustomEvent(type, label) {
        const eventLabel = JSON.stringify(label);
        const trackingEvent = new TrackingEvent(type, eventLabel, location(), eventUrl());
        this.log(trackingEvent);
    }

    registerListener() {

        $(document).on('click', TRACKING_DATA_CLICK_ATTRIBUTE, event => {
            const trackingData = $(event.currentTarget).data(TRACKING_CLICK_PROP);
            this.log(new TrackingEvent(trackingData.type, trackingData.label, location(), eventUrl()));

            // Avoid DoubleClick '_blank' window target bug
            if (event.target.href && event.target.getAttribute('target') === '_blank') {
                window.open(event.target.href, '_blank');
                return false;
            }
        });

        $(document).on('keypress', TRACKING_DATA_ENTER_ATTRIBUTE, event => {
            if (event.which === ENTER_KEY_CODE) {
                const trackingData = $(event.currentTarget).data(TRACKING_ENTER_PROP);
                this.log(new TrackingEvent(trackingData.type, trackingData.label, location(), eventUrl()));
            }
        });

        $(document).on('submit', TRACKING_DATA_SUBMIT, event => {
            const trackingData = $(event.currentTarget).data(TRACKING_SUBMIT_PROP);
            this.log(new TrackingEvent(trackingData.type, trackingData.label, location(), eventUrl()));
        });

        return this;
    }
}

module.exports = PageEventTracker;
